import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(frontend)/[lang]/error.tsx");
